// extracted by mini-css-extract-plugin
module.exports = {"categoryMenu":"map-category-menu_categoryMenu__1EGdp"};